export default "__VITE_ASSET__BcVh8mGe__"